export default __webpack_public_path__ + "static/media/StefanDesktop.f32d72eb.png";